const STATS = [
  { value: "1000+", label: "Couples Filmed" },
  { value: "100+", label: "Weddings Per Year" },
  { value: "10+", label: "Years in Essex" },
  { value: "5.0", label: "Average Rating" },
  { value: "8x", label: "Award Winners" },
];

const SERVICES = [
  {
    title: "Wedding Videography Essex",
    tagline: "Two videographers. Full day. Cinematic film.",
    points: [
      "Two videographers on every booking",
      "Full day coverage from bridal prep to first dance",
      "20 to 30 minute cinematic wedding film",
      "3 to 4 minute highlight film within 72 hours",
      "Full ceremony and speeches edits (multi camera)",
      "Drone footage (weather and location permitting)",
    ],
  },
  {
    title: "Wedding Photography Essex",
    tagline: "Documentary style. Natural moments. Editorial eye.",
    points: [
      "Full day coverage from prep to first dance",
      "Natural, documentary style photography",
      "Key moments captured as they happen",
      "500+ professionally edited photos",
      "Online gallery for easy sharing and downloads",
      "Designed to match the style of your film",
    ],
  },
  {
    title: "Combined Photo & Video",
    tagline: "One team. One style. Complete coverage.",
    points: [
      "One seamless team that works together every weekend",
      "Consistent visual style across photos and film",
      "Better coordination means no missed moments",
      "One supplier, one point of contact, no stress",
      "More cost effective than booking separately",
    ],
  },
];

const WHY_CHOOSE = [
  "Two videographers on every booking for full coverage",
  "Experienced team filming 100+ weddings per year",
  "Natural, unobtrusive approach. Guests forget we are there",
  "High-end cinematic editing with individually colour graded films",
  "Photography and videography designed to match in style",
  "Fast turnaround. Sneak peek highlight film within 72 hours",
  "1000+ weddings filmed across Essex, London, Kent, and the South East",
  "Award-winning. 8x Wedding Awards winner with a 5.0 average rating",
  "Recommended by 21 wedding venues across Essex",
  "No hidden charges. Interest free monthly payments available",
];

const VENUES = [
  "Gaynes Park",
  "Baddow Park",
  "High House",
  "Leez Priory",
  "Gosfield Hall",
  "Braxted Park",
  "Friern Manor",
  "Houchins",
  "Mulberry House",
  "Apton Hall",
  "The Lawn",
];

const PACKAGES = [
  {
    name: "The Wedding Video & Photo Collection",
    price: "From £3,000",
    desc: "Full day wedding videography and photography in one package. Two videographers and one photographer covering your entire day.",
    badge: "Complete Package",
  },
  {
    name: "The Wedding Video Collection",
    price: "From £2,295",
    desc: "Our most popular wedding videography package. Two videographers, full day, cinematic film, and all the individual edits.",
    badge: "Most Popular",
  },
  {
    name: "Photo & Highlight Video",
    price: "From £2,000",
    desc: "Wedding photography and a highlight film. One videographer and one photographer for up to 8 hours.",
  },
  {
    name: "The Photo Collection",
    price: "From £1,500",
    desc: "Dedicated wedding photography with one experienced photographer. Full day or up to 8 hours.",
  },
];

const TESTIMONIALS = [
  {
    quote:
      "I've watched our wedding film over 30 times and I cry every single time. It's the most incredible thing we own. Worth every single penny.",
    names: "Jessica & David",
    venue: "Gaynes Park, Essex",
  },
  {
    quote:
      "We weren't sure if we needed both a photographer and videographer but honestly it's the best decision we made. The photos are gorgeous and the film captured moments we didn't even know happened.",
    names: "Charlotte & James",
    venue: "Gosfield Hall, Essex",
  },
  {
    quote:
      "From the first call to receiving our photos and film, the whole experience was effortless. They knew exactly where to be at every moment. You'd never know they were there but they caught everything.",
    names: "Emily & Ben",
    venue: "Braxted Park, Essex",
  },
];

const FAQS = [
  {
    q: "How much does a wedding videographer cost in Essex?",
    a: "Most wedding videographers in Essex cost between £1,000 and £3,000 depending on coverage, number of videographers, and deliverables. At Wedding Video Essex, our most popular package starts from £2,295 and includes two videographers, full day coverage, a cinematic film, and all edits. Combined photo and video packages start from £3,000. All prices include digital delivery with no hidden charges.",
  },
  {
    q: "What does a wedding video package include?",
    a: "A standard Wedding Video Essex package includes two videographers for full day coverage from bridal prep to first dance. You receive a 20 to 30 minute cinematic wedding film, a 3 to 4 minute highlight reel within 72 hours, individual edits of the ceremony, speeches, cake cutting, and first dance, plus drone footage where the venue and weather allow.",
  },
  {
    q: "Is a wedding videographer worth it?",
    a: "Yes, and most couples who skip it say it's their biggest wedding regret. Photos are beautiful, but they can't capture the sound of your vows, the laughter during the speeches, or the moment you first see each other. We've filmed over 1000 couples since 2015, and the feedback we hear most is \"it was the best money we spent.\"",
  },
  {
    q: "How long does it take to receive your wedding video?",
    a: "We deliver a 3 to 4 minute sneak peek highlight film within 72 hours of your wedding. Your full 20 to 30 minute cinematic film and all additional edits are delivered within 12 to 16 weeks. Each film is individually edited and colour graded.",
  },
  {
    q: "Do you travel outside Essex?",
    a: "Yes. While we are based in Wickford, Essex, we regularly cover weddings across London, Kent, and the wider South East. We also travel further afield for destination weddings. There are no additional travel charges for venues within Essex.",
  },
  {
    q: "How far in advance should I book?",
    a: "We recommend booking 12 to 18 months in advance, particularly for Saturday weddings during peak season from May to September. We film over 100 weddings per year and only take a limited number of bookings per weekend.",
  },
  {
    q: "Will the videographer be intrusive during the wedding?",
    a: "No. Our approach is deliberately unobtrusive. We use long lenses and discreet equipment to capture moments without being noticed. Guests regularly tell couples they forgot we were there.",
  },
  {
    q: "Which Essex wedding venues do you cover?",
    a: "We have filmed at virtually every major wedding venue in Essex, including Gaynes Park near Epping, Gosfield Hall near Braintree, Braxted Park near Witham, Leez Priory near Chelmsford, High House near Burnham on Crouch, Baddow Park in Chelmsford, Friern Manor, Houchins, Mulberry House, Apton Hall, and The Lawn. We are recommended by 21 Essex venues.",
  },
];

const Overline = ({ children }) => (
  <div className="text-[#A9927D] text-xs tracking-overline uppercase font-medium mb-4">
    {children}
  </div>
);

const SectionHeading = ({ children }) => (
  <h2 className="font-display text-[#1F1E1D] text-3xl md:text-4xl leading-tight tracking-tight font-medium mb-6">
    {children}
  </h2>
);

export const SeoContent = () => (
  <div
    data-testid="seo-content"
    className="relative z-10 border-t border-[#1F1E1D]/15"
  >
    {/* Intro + stats */}
    <section className="px-6 md:px-12 lg:px-24 py-20 md:py-28">
      <div className="max-w-4xl">
        <Overline>Wedding Videographer & Photographer Essex</Overline>
        <SectionHeading>
          Cinematic wedding films & photography, based in Wickford, Essex
        </SectionHeading>
        <p className="text-[#5C5A56] text-base leading-relaxed font-light mb-4">
          Wedding Video Essex is an award-winning wedding videography and
          photography company founded by Alex Moore in 2015. We film over 100
          weddings per year and have captured more than 1000 weddings across
          Essex, London, Kent, and the South East, including venues in
          Chelmsford, Colchester, Brentwood, Southend, Epping, Braintree and
          Maldon.
        </p>
        <p className="text-[#5C5A56] text-base leading-relaxed font-light">
          Two videographers on every booking. Full day coverage from bridal
          prep to first dance. An 8x Wedding Awards winner with a 5.0 average
          review rating.
        </p>
      </div>
      <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8">
        {STATS.map((s) => (
          <div key={s.label} data-testid={`seo-stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="font-display text-[#2F2E2E] text-4xl md:text-5xl font-medium">
              {s.value}
            </div>
            <div className="text-[#8A8782] text-xs tracking-overline uppercase font-medium mt-2">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>

    {/* Services */}
    <section className="px-6 md:px-12 lg:px-24 py-20 bg-[#2F2E2E]">
      <Overline>Our Services</Overline>
      <h2 className="font-display text-white text-3xl md:text-4xl leading-tight tracking-tight font-medium mb-4">
        Wedding videography & photography Essex
      </h2>
      <p className="text-white/60 text-base leading-relaxed font-light max-w-2xl mb-14">
        We offer wedding videography, photography, and combined packages across
        Essex, London, Kent, and the South East. Every service is designed
        around natural, story-led coverage with a discreet approach.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {SERVICES.map((svc) => (
          <div
            key={svc.title}
            className="border border-white/10 bg-white/[0.03] p-8"
          >
            <h3 className="font-display text-white text-xl font-medium mb-2">
              {svc.title}
            </h3>
            <div className="text-[#CCBA56] text-xs tracking-overline uppercase font-medium mb-6">
              {svc.tagline}
            </div>
            <ul className="space-y-3">
              {svc.points.map((p) => (
                <li
                  key={p}
                  className="text-white/70 text-sm leading-relaxed font-light flex gap-3"
                >
                  <span className="text-[#CCBA56] shrink-0">&middot;</span>
                  {p}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>

    {/* Meet Alex + Why choose */}
    <section className="px-6 md:px-12 lg:px-24 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-2 gap-16">
      <div>
        <Overline>Your personal guide</Overline>
        <SectionHeading>Meet Alex, Head of Memory Making</SectionHeading>
        <div className="flex items-center gap-5 mb-8">
          <img
            src="https://customer-assets-7cd3h4nn.emergentagent.net/job_wedding-pricing-hub/artifacts/xn50zhjr_TEAM%20PHOTOS%2009-08-17%20007.webp"
            alt="Alex Moore, founder of Wedding Video Essex"
            data-testid="seo-alex-photo"
            className="w-24 h-24 md:w-28 md:h-28 rounded-full object-cover border-2 border-[#E5E3DB] shrink-0"
          />
          <div>
            <div
              className="font-display text-3xl text-[#2F2E2E] italic mb-1"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Alex Moore
            </div>
            <div className="text-xs tracking-overline uppercase text-[#8A8782] font-medium">
              Founder &amp; Head Videographer
            </div>
          </div>
        </div>
        <p className="text-[#5C5A56] text-base leading-relaxed font-light mb-4">
          From your very first message to the moment you watch your finished
          film, Alex is with you the whole way. No call centres. No being
          passed around. Just one person who genuinely cares about getting your
          day right.
        </p>
        <p className="text-[#5C5A56] text-base leading-relaxed font-light">
          He founded Wedding Video Essex because he believes every couple
          deserves a film that makes them feel it all again. Over 1000 happy
          couples later, he still gets emotional watching the final edits.
        </p>
      </div>
      <div>
        <Overline>Why couples choose us</Overline>
        <SectionHeading>Why choose Wedding Video Essex</SectionHeading>
        <ul className="space-y-3">
          {WHY_CHOOSE.map((w) => (
            <li
              key={w}
              className="text-[#5C5A56] text-sm leading-relaxed font-light flex gap-3"
            >
              <span className="text-[#A9927D] shrink-0">&middot;</span>
              {w}
            </li>
          ))}
        </ul>
      </div>
    </section>

    {/* Venues */}
    <section className="px-6 md:px-12 lg:px-24 py-20 border-t border-[#1F1E1D]/10">
      <Overline>Essex Wedding Venues</Overline>
      <SectionHeading>We know Essex venues inside out</SectionHeading>
      <p className="text-[#5C5A56] text-base leading-relaxed font-light max-w-2xl mb-10">
        We've photographed and filmed at all of these venues (and loads more).
        We know every angle, every lighting sweet spot, and every hidden
        corner.
      </p>
      <div className="flex flex-wrap gap-3">
        {VENUES.map((v) => (
          <span
            key={v}
            className="border border-[#1F1E1D]/20 text-[#2F2E2E] text-xs tracking-overline uppercase font-medium px-5 py-3 bg-white/60"
          >
            {v}
          </span>
        ))}
      </div>
    </section>

    {/* Packages */}
    <section className="px-6 md:px-12 lg:px-24 py-20 bg-[#2F2E2E]">
      <Overline>Packages</Overline>
      <h2 className="font-display text-white text-3xl md:text-4xl leading-tight tracking-tight font-medium mb-4">
        Simple pricing. No surprises.
      </h2>
      <p className="text-white/60 text-base leading-relaxed font-light max-w-2xl mb-14">
        Every package includes full digital delivery, no travel charges, and
        interest free monthly payments.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
        {PACKAGES.map((pkg) => (
          <div
            key={pkg.name}
            className={`border p-8 flex flex-col ${
              pkg.badge === "Most Popular"
                ? "border-[#CCBA56]/60 bg-[#CCBA56]/5"
                : "border-white/10 bg-white/[0.03]"
            }`}
          >
            {pkg.badge && (
              <div className="text-[#CCBA56] text-xs tracking-overline uppercase font-medium mb-4">
                {pkg.badge}
              </div>
            )}
            <h3 className="font-display text-white text-xl font-medium mb-3">
              {pkg.name}
            </h3>
            <p className="text-white/60 text-sm leading-relaxed font-light mb-6 flex-1">
              {pkg.desc}
            </p>
            <div className="font-display text-[#CCBA56] text-2xl font-medium">
              {pkg.price}
            </div>
          </div>
        ))}
      </div>
    </section>

    {/* Testimonials */}
    <section className="px-6 md:px-12 lg:px-24 py-20 md:py-28">
      <Overline>Don't take our word for it</Overline>
      <SectionHeading>Hear it from real Essex couples</SectionHeading>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mt-10">
        {TESTIMONIALS.map((t) => (
          <blockquote key={t.names} className="border-l border-[#A9927D]/60 pl-6">
            <p className="text-[#5C5A56] text-base leading-relaxed font-light italic mb-5">
              "{t.quote}"
            </p>
            <footer>
              <div className="text-[#1F1E1D] text-sm font-medium">
                {t.names}
              </div>
              <div className="text-[#8A8782] text-xs tracking-overline uppercase font-medium mt-1">
                {t.venue}
              </div>
            </footer>
          </blockquote>
        ))}
      </div>
    </section>

    {/* FAQ */}
    <section className="px-6 md:px-12 lg:px-24 py-20 border-t border-[#1F1E1D]/10">
      <Overline>Frequently asked questions</Overline>
      <SectionHeading>
        Wedding videographer & photographer Essex: FAQ
      </SectionHeading>
      <div className="max-w-3xl divide-y divide-[#1F1E1D]/10">
        {FAQS.map((f) => (
          <details key={f.q} className="group py-5" data-testid="seo-faq-item">
            <summary className="cursor-pointer list-none flex items-start justify-between gap-6 text-[#1F1E1D] text-base font-medium">
              {f.q}
              <span className="text-[#A9927D] shrink-0 transition-transform duration-300 group-open:rotate-45 text-xl leading-none">
                +
              </span>
            </summary>
            <p className="text-[#5C5A56] text-sm leading-relaxed font-light mt-4 pr-10">
              {f.a}
            </p>
          </details>
        ))}
      </div>
    </section>

    {/* Coverage note */}
    <section className="px-6 md:px-12 lg:px-24 py-16 bg-[#2F2E2E]">
      <p className="text-white/60 text-sm leading-relaxed font-light max-w-4xl">
        Wedding Video Essex is based in Wickford, Essex, UK. We cover weddings
        across the whole of Essex including Chelmsford, Colchester, Brentwood,
        Southend on Sea, Epping, Braintree, Maldon, Basildon, and Harlow, as
        well as London, Kent, and the wider South East. There are no additional
        travel charges for venues within Essex.
      </p>
    </section>
  </div>
);
